import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ItemForm from "../components/ItemForm";
import "../App.css";

export default function AddItem() {
  const navigate = useNavigate();

  const [values, setValues] = useState({
    name: "",
    image: "",
    material: "",
    quantity: 0
  });

  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    setBusy(true);
    setError("");

    try {
      const response = await fetch("https://ca2-team11-server-0rto.onrender.com/addrecyclable", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      });

      if (!response.ok) {
        throw new Error("Failed to add item");
      }

      const result = await response.json();
      alert(`✓ ${result.message}`);
      navigate("/allrecyclable"); // Changed from "/items" to "/itemlist"
    } catch (err) {
      setError(err.message || "Failed to add item. Please check your connection or try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="add-item-container">
      {busy && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          <p>Adding item...</p>
        </div>
      )}

      <div className="add-item-content">
        {/* Left Side - Information & Preview */}
        <div className="add-item-info">
          <div className="info-panel">
            <h3>📋 Item Information Guide</h3>
            <ul className="info-list">
              <li>
                <span className="info-icon">📷</span>
                <span>Add a clear image URL for better recognition</span>
              </li>
              <li>
                <span className="info-icon">🏷️</span>
                <span>Select the correct material type for proper sorting</span>
              </li>
              <li>
                <span className="info-icon">🔢</span>
                <span>Enter quantity to track recycling volume accurately</span>
              </li>
            </ul>
          </div>

          <div className="preview-card">
            <div className="preview-header">ITEM PREVIEW</div>
            <div className="preview-content">
              {values.image ? (
                <img 
                  src={values.image} 
                  alt="Preview" 
                  className="preview-image"
                  onError={(e) => {
                    e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200' viewBox='0 0 200 200'%3E%3Crect width='200' height='200' fill='%23f0f0f0'/%3E%3Ctext x='50%25' y='50%25' font-family='Arial' font-size='16' text-anchor='middle' fill='%23999'%3ENo Image%3C/text%3E%3C/svg%3E";
                  }}
                />
              ) : (
                <div className="preview-image empty">📷</div>
              )}
              <div className="preview-details">
                <h4>{values.name || "Item Name"}</h4>
                <p><strong>Material:</strong> {values.material || "Not selected"}</p>
                <p><strong>Quantity:</strong> {values.quantity || 0} units</p>
                {values.material && (
                  <div className="material-tag">{values.material}</div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Form */}
        <div className="add-item-form-wrapper">
          <div className="form-header">
            <div className="form-icon">♻️</div>
            <h2>Add New Item</h2>
          </div>
          
          <ItemForm
            values={values}
            onChange={setValues}
            onSubmit={handleSubmit}
            busy={busy}
            error={error}
            submitText="Add Item"
          />

          <div className="back-btn-container">
            <button 
              className="back-btn" 
              onClick={() => navigate("/allrecyclable")}
              disabled={busy}
            >
              ← Back to Item List
            </button>
          </div>
        </div>
      </div>
    </main>
  );
}